import { render, staticRenderFns } from "./MSecondaryDomainSubscribe.vue?vue&type=template&id=50a67eec&"
import script from "./MSecondaryDomainSubscribe.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryDomainSubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports